export const OPEN_CONTROL_PANEL = 'OPEN_CONTROL_PANEL'
export const SET_PARTICIPANTS = 'SET_PARTICIPANTS'
export const ADD_PARTICIPANT = 'ADD_PARTICIPANT'
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
export const SET_ACTIVE_EMOJI = 'SET_ACTIVE_EMOJI'
